import { Bounce, Slide, toast } from "react-toastify";
import "./toast.css";

export const successNotification = (text) => {
  return toast.success(text, {
    position: "top-center",
    autoClose: 1000,
    hideProgressBar: false,
    closeOnClick: false,
    // pauseOnHover: true,
    pauseOnHover: false,
    pauseOnFocusLoss: false,
    ////
    draggable: true,
    progress: undefined,
    theme: "dark",
    transition: Slide,
  });
};
export const infoNotification = (text) => {
  return toast.info(text, {
    position: "top-center",
    autoClose: 1000,
    hideProgressBar: false,
    closeOnClick: false,
    // pauseOnHover: true,
    pauseOnHover: false,
    pauseOnFocusLoss: false,
    ////
    draggable: true,
    progress: undefined,
    theme: "dark",
    transition: Slide,
  });
};
export const errorNotification = (text) => {
  return toast.error(text, {
    position: "top-center",
    autoClose: 1000,
    hideProgressBar: false,
    closeOnClick: false,
    // pauseOnHover: true,
    pauseOnHover: false,
    pauseOnFocusLoss: false,
    ////
    draggable: true,
    progress: undefined,
    theme: "dark",
    transition: Bounce,
  });
};

export const loadingNotification = (text) => {
  return toast.loading(text, {
    position: "top-center",
    hideProgressBar: false,
    closeOnClick: false,
    // pauseOnHover: true,
    pauseOnHover: false,
    pauseOnFocusLoss: false,
    ////
    draggable: true,
    progress: undefined,
    theme: "dark",
    transition: Bounce,
  });
};
export const updateToSuccessNotification = (id, text) =>
  toast.update(id, {
    render: text,
    type: "success",
    isLoading: false,
    autoClose: 1000,
    ////
    pauseOnHover: false,
    pauseOnFocusLoss: false,
  });

export const updateToError = (id, text) =>
  toast.update(id, {
    render: text,
    type: "error",
    isLoading: false,
    autoClose: 1000,
    ////
    pauseOnHover: false,
    pauseOnFocusLoss: false,
  });
